import React, { useContext, useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import SearchSidebar from "../components/Search/SearchSidebar";
import { Navigate, useLocation } from "react-router-dom";
import Content from "../components/Content";
import { ProductContext } from "../store";
import Cookies from 'js-cookie';
import Notification from "../components/Notification";
import { isPlatformOverviewPath, isAccountSettingsPath, isUserActivityPath } from "../utils/adminRoutes";

const Search = () => {
	const [isLogged, setIsLogged] = useState(true),
		location = useLocation(),
		isPlatformOverview = isPlatformOverviewPath(location.pathname),
		hideSearchSidebar =
			isPlatformOverview ||
			isAccountSettingsPath(location.pathname) ||
			isUserActivityPath(location.pathname),
		{ adminBootstrap, loadVisualEditor } = useContext(ProductContext);

	useEffect(() => {
		const Token = Cookies.get("_cb_admin_token");
		if (!Token) {
			setIsLogged(false);
		} else {
			adminBootstrap()
		}
	}, [])

	// const getWebsiteDetail = () => {
	// 	setWebsiteLoader(true);
	// 	PostData("ms1", "api/v1/user/getDetails").then(result => {
	// 		if (result !== "Invalid" && result !== undefined ) {
	// 			if( result.status === "success" ){
	// 				setWebsiteData(result.data.websites)
	// 			}
	// 		}
	// 		setWebsiteLoader(false)
	// 	});
	// }

	if (!isLogged) {
		return <Navigate to="/auth/login" replace />
	}

	// Redirect if user doesn't have search product type (only after data is loaded)
	// NOTE: admin portal always operates on search reports/dashboards;
	// selecting a user/store determines whether data exists. Avoid redirect loops.

	return (
		<>
			<section className={`applicationWrapper ${isPlatformOverview ? "platformOverviewPage" : ""}`}>
				<div className="applicationContentWrap">
					<Sidebar />
					{!loadVisualEditor && !hideSearchSidebar && <SearchSidebar />}
					<Content type="search" />
				</div>
				<Notification />
			</section>
		</>
	);
};

export default Search;
